import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;

    width: 100%;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: space-evenly;

    background: rgba(21, 19, 39, 0.95);

    border-top: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 -15px 20px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);

    border-radius: 20px 20px 0 0;

    padding: 0 5px;
`;

export const MobileLinkInside = styled.span`
    width: 40px;
    height: 40px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    span {
        filter: grayscale(1);
    }

    .yat-sprite {
        transform: translateY(2px);
    }
`;

const MobileButtonStyle = css`
    width: 60px;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    border: none;

    cursor: pointer;

    color: rgba(255, 255, 255, 0.5);
    transition:
        color 0.2s ease,
        filter 0.2s ease;

    font-size: 22px;

    &:active {
        color: #fff;
    }
`;

interface MobileLinkProps {
    $isActive?: boolean;
}

export const MobileButton = styled.button<MobileLinkProps>`
    ${MobileButtonStyle}

    ${({ $isActive }) =>
        $isActive &&
        css`
            color: #fff;

            ${MobileLinkInside} {
                background: linear-gradient(
                    91.77deg,
                    #e3ae59 -34.76%,
                    #90424c -10.86%,
                    #442753 79.81%,
                    #242135 115.58%
                );
            }
        `}
`;

export const MobileLink = styled(Link)<MobileLinkProps>`
    ${MobileButtonStyle}

    ${({ $isActive }) =>
        $isActive &&
        css`
            color: #fff;

            ${MobileLinkInside} {
                background: linear-gradient(
                    91.77deg,
                    #e3ae59 -34.76%,
                    #90424c -10.86%,
                    #442753 79.81%,
                    #242135 115.58%
                );
            }
        `}
`;
